import { Spinner, Stack } from "react-bootstrap"

const Loading = ({center=false}) => {
    return <div className={center?"loading-center":""} >
        <div style={{margin:"auto", display: "inline-block"}}><Stack  gap={2} direction="horizontal">
        <Spinner animation="grow" size="sm"/>
        <Spinner animation="grow" size="sm"/>
        <Spinner animation="grow" size="sm"/>
    </Stack></div>
    </div>
}

export default Loading
